import React from 'react';
import { Route, IndexRoute } from 'react-router';
import ActiveActions from './activeActions';

export default (
  <Route path="ativas">
    <IndexRoute component={(props) => <ActiveActions {...props} />} />
  </Route>
);
